import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-floating-squares',
  templateUrl: './floating-squares.component.html',
  styleUrls: ['./floating-squares.component.scss']
})
export class FloatingSquaresComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
